import { render, staticRenderFns } from "./ProjectContacts.vue?vue&type=template&id=c2f494c0"
import script from "./ProjectContacts.vue?vue&type=script&lang=js"
export * from "./ProjectContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports